/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RegionList = {
    type: 'array',
    contains: {
        type: 'Region',
    },
} as const;
